import { loginSuccess, loginFailure, logout } from '../slices/authSlice';
import { apiRequest } from '../../helpers/apiRequest';

export const loginUser = (username, password) => async (dispatch) => {
    try {
        const data = await apiRequest('/login', 'POST', { username, password });

        if (data.status === 1) {
            const user = data.data.user;
            const token = data.data.user.token;
            const group = data.data.group;
            const group_pertama = data.data.group_pertama;
            const menu_program = data.data.program_default;
            dispatch(loginSuccess({ user, token, group_pertama, group, menu_program }));
        } else {
            dispatch(loginFailure(data.message));
        }

        return data;

    } catch (error) {
        console.error('Error:', error);
        dispatch(loginFailure('Terjadi kesalahan. Silakan coba lagi.'));
        return { status: 0, message: 'Terjadi kesalahan. Silakan coba lagi.' };
    }
};

// Fungsi untuk logout
export const logoutUser = () => async (dispatch) => {
    const result = await apiRequest('/logout', 'POST');
    // An expired/revoked session is already logged out on the server.
    if (result.status !== 1 && result.message !== 'Unauthorized') {
        throw new Error(result.message || 'Logout gagal. Silakan coba lagi.');
    }
    dispatch(logout());
    return result;
};
